// illustrations used on templates selection buttons

import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";
import { FC } from "react";

const StudioModeIllustration = () => (
    <StyledIllustration
        fileName={"template_a.svg"}
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="60"
        fill="none"
        viewBox="0 0 90 60"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0859 13.2021C19.0859 11.9595 20.0933 10.9521 21.3359 10.9521H61.0763C62.3189 10.9521 63.3263 11.9595 63.3263 13.2021V37.7677L68.0028 50.0068C68.5656 51.4798 67.4779 53.0599 65.901 53.0599H23.1822C22.06 53.0599 21.1093 52.233 20.9539 51.1216L19.0859 37.7677L19.0859 13.2021Z"
            fill="#006EFA"
        />
        <path
            d="M22.4248 16.5278C22.4248 15.2922 23.4265 14.2905 24.6621 14.2905H57.7501C58.9857 14.2905 59.9874 15.2922 59.9874 16.5278V32.9214C59.9874 34.157 58.9857 35.1586 57.7501 35.1586H24.6621C23.4265 35.1586 22.4248 34.157 22.4248 32.9214V16.5278Z"
            fill="white"
        />
        <rect x="35.7803" y="16.7949" width="21.7028" height="15.8598" rx="1.5" fill="#FF9DFF" />
        <path
            d="M49.2158 24.0291C49.7158 24.3178 49.7158 25.0395 49.2158 25.3282L45.901 27.242C45.401 27.5306 44.776 27.1698 44.776 26.5924V22.7648C44.776 22.1875 45.401 21.8266 45.901 22.1153L49.2158 24.0291Z"
            fill="#282828"
        />
        <rect x="24.9287" y="16.7949" width="8.34724" height="6.67779" rx="1.5" fill="#FFD357" />
        <rect x="24.9287" y="25.9766" width="8.34724" height="6.67779" rx="1.5" fill="#FFD357" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.6387 42.3002C29.5433 41.4134 30.2382 40.6396 31.1301 40.6396H54.1761C54.8742 40.6396 55.48 41.1212 55.6374 41.8013L56.4968 45.5131C56.7145 46.4533 56.0005 47.3514 55.0355 47.3514H31.5298C30.7635 47.3514 30.1204 46.7739 30.0384 46.012L29.6387 42.3002Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <rect
            x="50.0884"
            y="3.30859"
            width="24.8495"
            height="13.3324"
            rx="6.66622"
            transform="rotate(15 50.0884 3.30859)"
            fill="#FF3D23"
        />
        <path
            d="M54.1912 9.04812L55.2163 9.3228L54.1927 13.1431L55.8602 13.5899L55.602 14.5535L52.9093 13.832L54.1912 9.04812ZM57.5349 9.94405L58.5668 10.2206L57.285 15.0045L56.253 14.728L57.5349 9.94405ZM60.5164 15.8703L59.6689 15.6433L59.1124 10.3668L60.2127 10.6616L60.5325 14.1973L62.5773 11.2952L63.6434 11.5808L60.5164 15.8703ZM62.907 16.5109L64.1888 11.727L67.0045 12.4814L66.7555 13.4109L64.9649 12.9311L64.7049 13.9016L66.3383 14.3392L66.0965 15.2413L64.4632 14.8037L64.1812 15.8561L65.9854 16.3396L65.7363 17.269L62.907 16.5109Z"
            fill="white"
        />
    </StyledIllustration>
);

const ExternalBroadcastIllustration = () => (
    <StyledIllustration
        fileName={"template_a.svg"}
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="60"
        fill="none"
        viewBox="0 0 90 60"
    >
        <rect x="36.75" y="7.5" width="36" height="30" rx="3" fill="#FFD357" />
        <path d="M66.0112 30L44.2612 30" stroke="#282828" stroke-width="1.5" stroke-linecap="round" />
        <path d="M66.0112 22.5L44.2612 22.5" stroke="#282828" stroke-width="1.5" stroke-linecap="round" />
        <path d="M66.0112 15L44.2612 15" stroke="#282828" stroke-width="1.5" stroke-linecap="round" />
        <circle cx="59.3965" cy="14.7622" r="2.25" transform="rotate(-180 59.3965 14.7622)" fill="#FF3D23" />
        <circle cx="59.3965" cy="30" r="2.25" transform="rotate(-180 59.3965 30)" fill="white" />
        <circle cx="49.1299" cy="22.5" r="2.25" transform="rotate(-180 49.1299 22.5)" fill="#006EFA" />
        <rect x="23.25" y="33.75" width="24.8495" height="13.3324" rx="6.66622" fill="#FF3D23" />
        <path
            d="M28.6984 38.2324H29.7597V42.1874H31.486V43.1851H28.6984V38.2324ZM32.16 38.2324H33.2284V43.1851H32.16V38.2324ZM36.5738 43.1851H35.6964L33.7932 38.2324H34.9323L36.1563 41.5648L37.3803 38.2324H38.4841L36.5738 43.1851ZM39.0487 43.1851V38.2324H41.9637V39.1946H40.11V40.1993H41.801V41.1332H40.11V42.2228H41.9779V43.1851H39.0487Z"
            fill="white"
        />
        <path
            d="M18.3782 34.7569C18.4224 32.9926 19.2041 31.2567 20.6745 30.048C22.1449 28.8393 23.9993 28.4083 25.7388 28.7064"
            className="sTone1"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
        <path
            d="M12.7861 33.9122C12.8577 30.7821 14.2411 27.7004 16.8495 25.5563C19.3679 23.4861 22.523 22.7055 25.5141 23.1362"
            className="sTone1"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
        <path
            d="M52.6023 45.1127C52.5581 46.8771 51.7764 48.613 50.306 49.8217C48.8356 51.0304 46.9812 51.4613 45.2416 51.1632"
            className="sTone1"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
        <path
            d="M58.1948 45.957C58.1232 49.087 56.7398 52.1687 54.1315 54.3128C51.613 56.383 48.458 57.1636 45.4669 56.7329"
            className="sTone1"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
    </StyledIllustration>
);

export const CustomIllustration = () => {
    return (
        <StyledIllustration
            fileName={"template_a.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width="90"
            height="60"
            fill="none"
            viewBox="0 0 90 60"
        >
            <rect
                x="15.75"
                y="14.2913"
                width="24"
                height="24"
                rx="3"
                transform="rotate(-15 15.75 14.2913)"
                fill="#FF9DFF"
            />
            <rect x="25.5" y="15.75" width="36" height="30" rx="3" fill="#FFD357" />
            <path d="M54.7607 38.2499L33.0107 38.2499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M54.7607 30.7499L33.0107 30.7499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M54.7607 23.2499L33.0107 23.2499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="48.1465" cy="23.0118" r="2.25" transform="rotate(-180 48.1465 23.0118)" fill="white" />
            <circle cx="48.1465" cy="38.2499" r="2.25" transform="rotate(-180 48.1465 38.2499)" fill="#FF3D23" />
            <circle cx="37.8799" cy="30.7499" r="2.25" transform="rotate(-180 37.8799 30.7499)" fill="#006EFA" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.2883 28.4405C65.7234 25.5739 68.4001 23.6027 71.2667 24.0379V24.0379C74.1334 24.473 76.1045 27.1496 75.6694 30.0163V30.0163C75.2343 32.883 72.5576 34.8541 69.691 34.419V34.419C66.8243 33.9838 64.8532 31.3072 65.2883 28.4405V28.4405Z"
                fill="#006EFA"
            />
            <path
                d="M68.3507 29.0903L69.6954 30.942L73.1821 27.9747"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </StyledIllustration>
    );
};

/**
 * Illustrations map for room templates
 * Maps template illustration names to their respective components
 */
export const illustrationsMap: Record<string, FC> = {
    StudioModeIllustration: StudioModeIllustration,
    ExternalBroadcastIllustration: ExternalBroadcastIllustration,
};
